// Constructor
function FriendFoe(app) {
  this.app = app;
  this.data = false;
  this.sex = "male";
  this.currentInsect = -1;

  this.loadData();
}

FriendFoe.prototype.loadData = function (gameName) {
  $.ajax({
    url: "friendfoe.html",
    dataType: 'html',
    cache: false,
    complete: $.proxy(function (data, textStatus) {
      $("#game").html(data.responseText);
      // this.app.initSVG();

      $.ajax({
        url: "friendfoe.json",
        dataType: 'json',
        cache: false,
        complete: $.proxy(function (data) {
          this.data = JSON.parse(data.responseText);
          this.init();
        }, this)
      });

    }, this)
  });
};

FriendFoe.prototype.init = function () {

  this.app.initSVG();

  $(".guide").hide();

  // Init a few things
  this.initScene();
  this.initLastScren();

  // Stop screensaver animation for better performance
  $("#screensaver .part .animation").addClass("paused");

  // Set audio triggers
  $(".language-setter, .action, .button, .btn-lang, .home").on("click", $.proxy(function () {
    this.app.audio.play("audio/Click2.wav");
  }, this));

  // Quick start
  // $("#title-screen").fadeOut("normal");
  // this.app.i18n.set("fr");
  // this.gotoGame("male");
  // this.closeGameModal();
  // this.gotoLastScreen();

};


FriendFoe.prototype.start = function () {
  $("#title-screen").fadeOut("normal", $.proxy(function () {
    $("#title-screen").removeClass("active");
    $("#persos-screen").addClass("active").fadeTo("normal", 1);
    this.showContextualIntro();
  }, this));
};


FriendFoe.prototype.initScene = function () {

  // this.data

  var $el = $("#game-screen .landscape-wrapper");

  for (var i = 0; i < this.data.insects.length; i++) {
    var insect = this.data.insects[i];

    // Instances
    for (var j = 0; j < insect.instances.length; j++) {
      var instance = insect.instances[j];
      var instanceEl = $('<div class="insect"><div class="parts-wrapper"><div class="parts-active-wrapper"><div class="part part2"></div><div class="part part3"></div><div class="part part1"></div><div class="part part4"></div></div></div></div>');
      instanceEl.addClass("insect-" + insect.code);
      instanceEl.addClass("insect-type-" + instance.type);
      instanceEl.data("insect-id", i);
      instanceEl.css({
        "animation": "flying-" + insect.behaviour.flying + " " + (Math.round(Math.random() * 4 + 6) / 2) + "s " + insect.behaviour.easing + " infinite",
        "left": instance.x + "px",
        "top": instance.y + "px",
      });

      instanceEl.find(".parts-wrapper").css({
        "transform": "scale(" + instance.scale + ")",
      });

      // Add animation variation
      instanceEl.find(".part").css({
        "animationDuration": Math.round(Math.random() * 1 + 2) + "s",
      })


      $el.append(instanceEl);
    }

    // Score
    var scoreMarkerEl = $("#score-model").clone();
    scoreMarkerEl.attr("id", "");
    scoreMarkerEl.addClass("insect-" + insect.code);
    scoreMarkerEl.data("insect-id", i);
    scoreMarkerEl.find("img").attr("src", insect.real_image);
    $(".score-wrapper").append(scoreMarkerEl);

  }

  $("#score-model").remove();

  $(".insect").click($.proxy(function (e) {
    this.app.audio.play("audio/Woosh.wav");
    this.showGameModal("question", $(e.currentTarget).data("insect-id"));
  }, this))

};


FriendFoe.prototype.initLastScren = function () {

  for (var i = 0; i < this.data.insects.length; i++) {
    var insect = this.data.insects[i];
    var insectEl = $("#last-screen-insect-model").clone();
    insectEl.removeAttr("id");
    insectEl.find(".fr").text(insect.name_fr);
    insectEl.find(".en").text(insect.name_en);
    insectEl.find("img.insect-image").attr("src", insect.real_image);

    if (insect.is_friend) {
      $("#last-screen .friends-wrapper").append(insectEl);
    } else {
      $("#last-screen .foe-wrapper").append(insectEl);
    }
  }

  $("#last-screen-insect-model").remove();

}

FriendFoe.prototype.gotoGame = function (selection) {

  console.log("go to game screen");

  // Save sex
  this.sex = selection;

  // Add body class for sex
  $("body").removeClass("male female").addClass(selection);
  $("#game-modal .perso").removeClass("male female").addClass(this.sex);
  // $("#perso").alterClass("type-*").addClass("type-" + (this.sex == "female" ? "farmer1" : "farmer2"));

  // Got to game screen
  $("#persos-screen").fadeOut("normal", $.proxy(function () {
    $("#persos-screen").removeClass("active");
    $("#game-screen").addClass("active").fadeTo("normal", 1);
    this.showGameModal("intro");
  }, this));
};

FriendFoe.prototype.returnToScene = function () {
  this.removeInsectFromScene(this.currentInsect)
  this.closeGameModal();
}

FriendFoe.prototype.removeInsectFromScene = function (insectId) {

  // Remove insects with code
  var insectCode = this.data.insects[insectId].code;
  $(".insect.insect-" + insectCode).addClass("caught");
  // console.log("Removed insects of code " + insectCode + ".")

  // Update score
  $(".score.insect-" + insectCode).addClass("caught");

  // Count remaining insects
  var remainingInsects = $(".insect:not(.caught)").length;
  // console.log(remainingInsects + " remaining insects.", $(".insect:not(.caugth)"))

  if (remainingInsects <= 0) {
    this.gotoLastScreen();
  }

}

FriendFoe.prototype.gotoLastScreen = function () {

  console.log("goto last screen");

  // // Add sex to perso
  $("#last-screen").removeClass("male female").addClass(this.sex);

  // Animate
  $("#game-screen").fadeOut("normal", $.proxy(function () {
    $("#game-screen").removeClass("active");
    $("#last-screen").addClass("active").fadeTo("normal", 1);
  }, this));
};

FriendFoe.prototype.showHelp = function () {
  this.app.showModal("#help");
}

FriendFoe.prototype.closeHelp = function () {
  this.app.closeModal("#help");
}

FriendFoe.prototype.showContextualIntro = function () {
  this.app.showModal("#contextual-intro");
}

FriendFoe.prototype.closeContextualIntro = function () {
  this.app.closeModal("#contextual-intro");
}

FriendFoe.prototype.gameModalSelect = function (selection) {
  $("#game-modal .box .box-content-question").fadeOut(400, $.proxy(function () {
    this.showGameModal("feedback", this.currentInsect, selection);
  }, this));
}

FriendFoe.prototype.showGameModal = function (mode, insectId, answer) {

  // Hide current content, show new content
  $("#game-modal .box-content").hide();
  $("#game-modal .box-content-" + mode).fadeIn(400);
  $("#game-modal #perso").removeClass("unhappy").addClass("happy");

  // Set insect data
  if ((typeof insectId != "undefined")) {
    this.currentInsect = insectId;
    $("#game-modal .box-content .insect-image").attr("src", this.data.insects[insectId].real_image);
    $("#game-modal .box-content .insect-name .fr p").text(this.data.insects[insectId].name_fr);
    $("#game-modal .box-content .insect-name .en p").text(this.data.insects[insectId].name_en);
    $("#game-modal .box-content .insect-description .fr p").html(this.data.insects[insectId].description_fr);
    $("#game-modal .box-content .insect-description .en p").html(this.data.insects[insectId].description_en);

    // Handle french gender
    var frenchGenderIsFeminin = (this.data.insects[this.currentInsect].french_gender == "feminin");
    $("#game-modal").find(".box-content-feedback, .box-content-question").find(".fr.masculin").toggle(!frenchGenderIsFeminin);
    $("#game-modal").find(".box-content-feedback, .box-content-question").find(".fr.feminin").toggle(frenchGenderIsFeminin);

  }

  // Handle feedback data
  if (mode == "feedback") {
    var isFriend = this.data.insects[this.currentInsect].is_friend;
    var isGoodAnswer = (isFriend && answer == "friend") || (!isFriend && answer == "foe");
    $("#game-modal .box-content-feedback .title.good").toggle(isGoodAnswer == true);
    $("#game-modal .box-content-feedback .title.wrong").toggle(isGoodAnswer == false);
    $("#game-modal #perso").toggleClass("happy", isGoodAnswer).toggleClass("unhappy", !isGoodAnswer);
    $("#game-modal .box-content-feedback .good-answer-reveal-wrapper .friend").toggle(isFriend);
    $("#game-modal .box-content-feedback .good-answer-reveal-wrapper .foe").toggle(!isFriend);
  }

  // Handle perso display
  if (mode == "question") {
    $("#game-modal #perso").hide();
  } else {
    $("#game-modal #perso").fadeIn(400);
  }

  this.app.showModal("#game-modal", false);
}

FriendFoe.prototype.closeGameModal = function (callback) {
  callback = (typeof callback != "undefined") ? callback : false;
  this.app.closeModal("#game-modal", callback);
}

FriendFoe.prototype.reset = function () {

  this.sex = "male";
  this.currentInsect = -1;

  // Reset is called when returning to screensaver

  // Close help
  this.closeHelp();
  this.closeContextualIntro();
  this.closeGameModal();

  $(".insect").removeClass("caught");
  $(".score").removeClass("caught");


  // Animate in/out and reset classes
  $(".screen.active").fadeOut("normal", $.proxy(function () {
    $(".screen").removeClass("active");
    $("#title-screen").addClass("active").fadeTo("normal", 1);
  }, this));

  // this.animationEngine.killTweens();

};


// Expose FriendFoe
window.FriendFoe = FriendFoe;
